import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  FaSearch,
  FaGoogle,
  FaFacebookF,
  FaYoutube,
  FaSms,
  FaEnvelope,
  FaFileAlt,
  FaWhatsapp,
  FaShoppingCart,
  FaPaintBrush,
  FaHashtag,
  FaCode,
  FaArrowRight,
} from 'react-icons/fa';
import Navbar2 from '../Components/Navbar2';
import FooterSection from '../Components/Homepage2/FooterSection';
import PageSEO from '../Components/SEO/PageSEO';
import PersistentCTA from '../Components/CRO/PersistentCTA';
import StickyMobileCTA from '../Components/CRO/StickyMobileCTA';
import { servicesData } from '../data/servicesData';

const iconMap = {
  FaSearch,
  FaGoogle,
  FaFacebookF,
  FaYoutube,
  FaSms,
  FaEnvelope,
  FaFileAlt,
  FaWhatsapp,
  FaShoppingCart,
  FaPaintBrush,
  FaHashtag,
  FaCode,
};

const E = [0.16, 1, 0.3, 1];

const col = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

const fadeUp = {
  hidden: { opacity: 0, y: 22 },
  show: { opacity: 1, y: 0, transition: { duration: 0.75, ease: E } },
};

const OurServices = () => {
  return (
    <>
      <PageSEO 
        title="Top Digital Marketing & Custom Software Development Services In Ramamurthy Nagar"
        description="Explore our high-performance digital services at Cyborgsapient Pvt. Ltd. Ramamurthy Nagar. We offer SEO, custom software development, Meta Ads, and AI automation."
        keywords="digital marketing services in ramamurthy nagar, software development ramamurthy nagar, seo agency ramamurthy nagar, web design ramamurthy nagar, digital marketing company in Bangalore, SEO services in Bangalore, SEO company near me, best digital marketing agency in Bangalore, website development company Bangalore, social media marketing Bangalore, Google Ads agency Bangalore, local SEO services Bangalore, digital marketing agency near me, affordable SEO services Bangalore, SEO expert in Bangalore, PPC services Bangalore, app development company Bangalore, lead generation company Bangalore, best SEO company in Bangalore, digital marketing company in Ramamurthy Nagar, SEO services in Ramamurthy Nagar, best digital marketing agency in Ramamurthy Nagar, website development company Ramamurthy Nagar, social media marketing Ramamurthy Nagar, Google Ads agency Ramamurthy Nagar, local SEO services Ramamurthy Nagar, affordable SEO services Ramamurthy Nagar, SEO expert in Ramamurthy Nagar, PPC services Ramamurthy Nagar, app development company Ramamurthy Nagar, lead generation company Ramamurthy Nagar, best SEO company in Ramamurthy Nagar"
        url="https://cyborgsapient.com/services"
      />
      <Navbar2 />

      <div className="relative w-full bg-[#FAFBF9] text-[#1D1D1F] font-sans selection:bg-[#EAECE9] selection:text-[#1C2E1E] antialiased overflow-x-hidden pt-20 lg:pt-24">
        
        {/* ── Ambient glows (GPU-safe) ── */}
        <div className="absolute top-0 right-0 w-[600px] h-[500px] pointer-events-none"
          style={{ background: 'radial-gradient(ellipse at 80% 20%, rgba(112,0,255,0.04) 0%, transparent 60%)' }} />
        <div className="absolute top-[800px] left-0 w-[500px] h-[400px] pointer-events-none"
          style={{ background: 'radial-gradient(ellipse at 20% 80%, rgba(255,115,50,0.03) 0%, transparent 60%)' }} />

        {/* ── HERO SECTION ── */}
        <section className="relative overflow-hidden pt-16 sm:pt-24 lg:pt-28 pb-16 sm:pb-24 lg:pb-28">
          <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16 flex flex-col lg:flex-row items-center gap-16 lg:gap-20">
            
            {/* Text details */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: E }}
              className="lg:w-1/2"
            >
              <span className="text-[11px] uppercase tracking-[0.28em] text-[#5A635A] font-semibold block mb-8">
                ✦&nbsp;&nbsp;Capabilities&nbsp;&nbsp;✦
              </span>
              <h1 className="text-[44px] sm:text-5xl md:text-6xl font-extralight text-[#1D1D1F]/30 leading-[1.05] tracking-tight">
                Full-stack digital.
              </h1>
              <h1 className="text-[44px] sm:text-5xl md:text-6xl font-black text-[#1D1D1F] leading-[1.05] tracking-tight mb-8">
                <span className="bg-gradient-to-r from-[#FF7332] via-[#FF1E90] to-[#7000FF] bg-clip-text text-transparent inline pb-2">
                  Built to perform.
                </span>
              </h1>
              <p className="text-base sm:text-lg text-[#5A635A] font-light leading-[1.75] max-w-[44ch] mb-10">
                Connoisseur of what our customers need sets us apart. With technology reshaping business hourly,
                traditional strategies are no longer enough. At Cyborg Sapient, we operate as an integrated unit to deploy custom code and growth campaigns.
              </p>
              <div>
                <a
                  href="#services-list"
                  className="inline-flex items-center gap-2.5 px-8 py-4 bg-[#1C2E1E] text-white rounded-full text-sm font-semibold tracking-wide hover:bg-black transition-colors duration-200 group shadow-md"
                >
                  Explore Services
                  <FaArrowRight size={11} className="group-hover:translate-x-1 transition-transform" />
                </a>
              </div>
            </motion.div>

            {/* Image tile */}
            <motion.div 
              initial={{ opacity: 0, scale: 0.97 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.9, ease: E, delay: 0.1 }}
              className="lg:w-1/2 flex justify-center"
            >
              <div 
                className="relative overflow-hidden rounded-[28px] w-full max-w-md"
                style={{ boxShadow: '0 32px 64px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)' }}
              >
                <img
                  src="https://img.freepik.com/premium-photo/multiethnic-business-team-discussing-strategy-meeting-room-office-generative-ai_868783-4041.jpg?w=2000"
                  alt="Cyborg Sapient team discussing strategy and business transformation"
                  className="object-cover w-full h-full rounded-[28px] aspect-[16/11]"
                  loading="eager"
                />
              </div>
            </motion.div>

          </div>
        </section>

        {/* ── SERVICES GRID SECTION ── */}
        <section id="services-list" className="relative bg-white border-t border-[#F1F3F1] py-24 sm:py-36">
          <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
            
            {/* Heading */}
            <motion.div
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: '-80px' }}
              variants={col}
              className="mb-16 sm:mb-24"
            >
              <motion.span variants={fadeUp} className="text-[11px] uppercase tracking-[0.28em] text-[#5A635A] font-semibold block mb-6">
                ✦&nbsp;&nbsp;Service Offerings&nbsp;&nbsp;✦
              </motion.span>
              <motion.h2 variants={fadeUp} className="text-4xl sm:text-[52px] font-extralight text-[#1D1D1F]/30 leading-[1.05] tracking-tight">
                Explore our
              </motion.h2>
              <motion.h2 variants={fadeUp} className="text-4xl sm:text-[52px] font-bold text-[#1D1D1F] leading-[1.05] tracking-tight -mt-1">
                Digital Services.
              </motion.h2>
              <motion.p variants={fadeUp} className="text-base text-[#5A635A] font-light max-w-md mt-6 leading-[1.75]">
                Comprehensive digital solutions engineered to elevate campaign response and product stability. Click on any program to read more.
              </motion.p>
            </motion.div>

            {/* Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {servicesData.map((service, i) => {
                const IconComponent = iconMap[service.icon];
                const displayIndex = String(i + 1).padStart(2, '0');
                return (
                  <motion.div
                    key={service.id}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: '-40px' }}
                    transition={{ duration: 0.5, delay: Math.min(i * 0.05, 0.2), ease: 'easeOut' }}
                  >
                    <Link to={`/services/${service.slug}`} className="block h-full group">
                      <div className="bg-[#FAFBF9] border border-[#EAECE9] rounded-[28px] p-8 relative overflow-hidden flex flex-col justify-between group hover:border-[#1C2E1E] transition-all duration-350 min-h-[300px]">
                        
                        {/* Number watermark */}
                        <div className="absolute right-6 top-4 text-[80px] font-black text-black/[0.03] leading-none select-none pointer-events-none">
                          {displayIndex}
                        </div>

                        <div>
                          {/* Badge */}
                          <span className="inline-flex px-3 py-1 bg-[#F1F3F1] rounded-full text-[10px] font-semibold uppercase tracking-wider text-[#5A635A] mb-8 w-fit">
                            Core Service
                          </span>

                          {/* Icon Container */}
                          <div className="w-11 h-11 rounded-[12px] bg-white border border-[#EAECE9] flex items-center justify-center mb-6 group-hover:bg-[#1C2E1E] group-hover:border-[#1C2E1E] transition-colors duration-250">
                            {IconComponent && (
                              <IconComponent size={16} className="text-[#1C2E1E] group-hover:text-white transition-colors duration-250" />
                            )}
                          </div>

                          {/* Title */}
                          <h3 className="text-xl font-bold text-black mb-3 tracking-tight group-hover:bg-gradient-to-r group-hover:from-[#FF7332] group-hover:via-[#FF1E90] group-hover:to-[#7000FF] group-hover:bg-clip-text group-hover:text-transparent transition-all">
                            {service.title}
                          </h3>

                          {/* Description */}
                          <p className="text-[#5A635A] text-sm leading-relaxed mb-6 font-light">
                            {service.shortDesc}
                          </p>
                        </div>

                        {/* CTA Handoff Link */}
                        <div className="flex items-center gap-2 pt-5 border-t border-[#F1F3F1] text-[11px] font-semibold uppercase tracking-wider text-[#1C2E1E]/40 group-hover:text-[#1C2E1E] transition-colors duration-250">
                          <span>Explore Service</span>
                          <FaArrowRight size={9} className="group-hover:translate-x-1 transition-transform" />
                        </div>

                      </div>
                    </Link>
                  </motion.div>
                );
              })}
            </div>

          </div>
        </section>

        {/* ── BOTTOM CTA SECTION ── */}
        <section className="px-6 sm:px-10 lg:px-16 pb-28 sm:pb-36 bg-white max-w-[1200px] mx-auto relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: E }}
            className="relative overflow-hidden rounded-[32px] bg-[#1C2E1E] px-10 sm:px-16 py-14 sm:py-20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-10"
          >
            {/* Ambient accent */}
            <div
              className="absolute inset-0 pointer-events-none"
              style={{ background: 'radial-gradient(ellipse at 5% 50%, rgba(255,115,50,0.14) 0%, transparent 50%)' }}
            />

            <div className="relative z-10">
              <span className="text-[11px] uppercase tracking-[0.28em] text-white/40 font-semibold block mb-5">
                ✦&nbsp;&nbsp;Custom Scope&nbsp;&nbsp;✦
              </span>
              <h3 className="text-3xl sm:text-4xl font-bold text-white tracking-tight leading-[1.05]">
                Need a{' '}
                <span className="bg-gradient-to-r from-[#FF7332] via-[#FF1E90] to-[#7000FF] bg-clip-text text-transparent inline pb-1">
                  tailored<br />digital stack?
                </span>
              </h3>
            </div>

            <div className="relative z-10 flex-shrink-0 flex flex-col sm:items-end gap-4">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2.5 px-8 py-4 bg-white text-[#1C2E1E] rounded-full text-sm font-semibold tracking-wide hover:bg-[#F4F5F4] transition-colors duration-200 group"
              >
                Get Custom Plan
                <FaArrowRight size={11} className="group-hover:translate-x-1 transition-transform duration-200" />
              </Link>
            </div>
          </motion.div>
        </section>

        {/* Minimal Footer */}
        <FooterSection />

        <PersistentCTA />
        <StickyMobileCTA />
      </div>
    </>
  );
};

export default OurServices;
